import React from "react";
import AnimatedCardContent from "./components/AnimatedCardContent";
import PageContainer from "../custom/Page";
import UserFilters from "./components/Reports/Users/UsersFilters";
import moment from "moment";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Grid, Typography } from "@material-ui/core";
import { SORT, USER_FILTER_KEYS } from "../util";
import UserListTable from "./components/Reports/Users/byIndividual/UserListTable";
import HeaderReportUsers from "./components/Reports/Users/byIndividual/HeaderReportUsers";

const SelectWrapper = React.memo(({ children }) => (
  <Grid
    item
    xs={12}
    sm={6}
    md={3}
  >
    {children}
  </Grid>
));

const IGNORED_FILTERS = new Set([USER_FILTER_KEYS.SELECTED_MONTH_YEAR, USER_FILTER_KEYS.SORT, USER_FILTER_KEYS.ORDER_BY]);

const ReportUsersPage = () => {
  const currentUser = useSelector((state) => state.user.user.me);
  const [userFilters, setUserFilters] = React.useState({
    [USER_FILTER_KEYS.COUNTRIES]: [],
    [USER_FILTER_KEYS.STATES]: [],
    [USER_FILTER_KEYS.CITIES]: [],
    [USER_FILTER_KEYS.ROLES]: [],
    [USER_FILTER_KEYS.CUSTOMER_SITUATIONS]: [],
    [USER_FILTER_KEYS.AGENT_SITUATIONS]: [],
    [USER_FILTER_KEYS.AGE_RANGES]: [],
    [USER_FILTER_KEYS.HAS_BENEFICIARY]: [],
    [USER_FILTER_KEYS.EMAIL_CONFIRMATION]: [],
    [USER_FILTER_KEYS.USERS]: [],
    [USER_FILTER_KEYS.AGENTS]: [],
    [USER_FILTER_KEYS.SELECTED_MONTH_YEAR]: moment(),
    [USER_FILTER_KEYS.SORT]: SORT.DESC,
    [USER_FILTER_KEYS.ORDER_BY]: "id",
  });

  const updateFilter = React.useCallback((key, value) => {
    setUserFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  const hasActiveFilters = React.useMemo(() => {
    return Object.entries(userFilters).some(([key, value]) => {
      if (IGNORED_FILTERS.has(key)) return false;

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      return Boolean(value);
    });
  }, [userFilters]);

  return (
    <PageContainer full>
      <HeaderReportUsers
        title="app.report.customer"
        userFilters={userFilters}
      />

      <AnimatedCardContent>
        <UserFilters
          userFilters={userFilters}
          setUserFilters={setUserFilters}
          fetchStatesEnabled
          fetchCitiesEnabled
          WrapperComponent={SelectWrapper}
        />
      </AnimatedCardContent>
      {hasActiveFilters ? (
        <UserListTable
          filters={userFilters}
          currentUser={currentUser}
          orderBy={userFilters.orderBy}
          sort={userFilters.sort}
          setOrderBy={(value) => updateFilter(USER_FILTER_KEYS.ORDER_BY, value)}
          setSort={(value) => updateFilter(USER_FILTER_KEYS.SORT, value)}
        />
      ) : (
        <AnimatedCardContent>
          <Typography align="center">
            <FormattedMessage id="app.report.filters.required" />
          </Typography>
        </AnimatedCardContent>
      )}
    </PageContainer>
  );
};

export default ReportUsersPage;
